export default __webpack_public_path__ + "static/media/car-service.c8e3f48b.gif";